import React, { useState } from 'react';
import {
  Phone, Mail, MessageCircle, MapPin, Globe, Instagram, Facebook,
  Youtube, Music2, Calendar, Mic, FlaskConical, Building2,
  Copy, Check, ExternalLink, HeartHandshake, Gift, ChevronDown,
  ArrowUpRight
} from 'lucide-react';

// ── Dados ──────────────────────────────────────────────────────────────────

const FILIACAO_DOACAO = [
  {
    label: 'Faça já sua filiação',
    desc: 'Conheça os benefícios e como se federar',
    href: 'https://www.federacaodoscabeleireiros.com.br/filiacao',
    icon: <HeartHandshake className="w-5 h-5" />,
    color: 'bg-amber-600',
  },
  {
    label: 'Faça sua doação',
    desc: 'Apoie a Federação — PayPal Fundraiser',
    href: 'https://www.paypal.com/fundraiser/charity/4901049',
    icon: <Gift className="w-5 h-5" />,
    color: 'bg-emerald-600',
  },
  {
    label: 'Filie-se agora',
    desc: 'Pagamento via Mercado Pago',
    href: 'https://link.mercadopago.com.br/federacaodasescolas',
    icon: <HeartHandshake className="w-5 h-5" />,
    color: 'bg-sky-600',
  },
];

const CONTATO = [
  {
    label: 'WhatsApp 1',
    desc: '(11) 99973-3976',
    href: 'https://api.whatsapp.com/send?phone=5511999733976',
    icon: <MessageCircle className="w-5 h-5" />,
    color: 'bg-green-600',
  },
  {
    label: 'WhatsApp 2',
    desc: '(11) 97387-1492',
    href: 'https://api.whatsapp.com/send?phone=5511973871492',
    icon: <MessageCircle className="w-5 h-5" />,
    color: 'bg-green-600',
  },
  {
    label: 'E-mail',
    desc: 'contato@federacaodoscabeleireiros.com.br',
    href: 'mailto:contato@federacaodoscabeleireiros.com.br',
    icon: <Mail className="w-5 h-5" />,
    color: 'bg-purple-600',
  },
  {
    label: 'Localização',
    desc: 'Rua Paulo de Faria, 182 Cj.46 — Tucuruvi, SP',
    href: 'https://maps.google.com?q=Federa%C3%A7%C3%A3o%20das%20Escolas%20Profissionais%20de%20Cabeleireiros%20-Rua%20Paulo%20de%20Faria%2C%20182%20Cj.46%20-%20Tucuruvi%20-%20S%C3%A3o%20Paulo%20-%20SP',
    icon: <MapPin className="w-5 h-5" />,
    color: 'bg-red-600',
  },
];

const REDES = [
  {
    label: 'Site Oficial',
    desc: 'fepcssp.org.br',
    href: 'http://www.federacaodoscabeleireiros.com.br',
    icon: <Globe className="w-5 h-5" />,
    color: 'bg-amber-600',
  },
  {
    label: 'Instagram Oficial',
    desc: '@fepcssp',
    href: 'http://www.instagram.com/fepcssp',
    icon: <Instagram className="w-5 h-5" />,
    color: 'bg-pink-600',
  },
  {
    label: 'Facebook Oficial',
    desc: 'facebook.com/federacaodasescolas',
    href: 'http://www.facebook.com/federacaodasescolas',
    icon: <Facebook className="w-5 h-5" />,
    color: 'bg-blue-700',
  },
  {
    label: 'TikTok Oficial',
    desc: '@federacaodasescolas',
    href: 'http://www.tiktok.com/@federacaodasescolas',
    icon: <Music2 className="w-5 h-5" />,
    color: 'bg-neutral-800',
  },
];

const EVENTOS = [
  {
    label: 'BARBER WEEK 2026 ESTÁ CHEGANDO!',
    desc: '15 e 16 de novembro de 2026 • Expo Center Norte, São Paulo',
    details: 'O maior encontro barber do mundo reúne feira, congresso, workshops, marcas e profissionais em dois dias de técnica, negócios e networking.',
    href: 'https://1mc.co/yjPKkt',
    faviconDomain: 'barberweek.com.br',
    badge: 'EM BREVE',
    accent: 'from-stone-950 via-stone-800 to-amber-700',
  },
  {
    label: 'BEAUTY FAIR 2026',
    desc: '5 a 8 de setembro de 2026 • Expo Center Norte, São Paulo',
    details: 'Faça seu credenciamento para a maior feira de beleza das Américas, com milhares de marcas, lançamentos, conteúdo e oportunidades para profissionais do setor.',
    href: 'https://beautyfair.com.br/credenciamento/',
    faviconDomain: 'beautyfair.com.br',
    badge: 'CREDENCIAMENTO',
    accent: 'from-fuchsia-950 via-purple-800 to-pink-500',
  },
];

const DESTAQUES = [
  {
    label: 'Agno',
    desc: 'Conheça a plataforma Agno',
    details: 'Acesse o site oficial da Agno para conhecer a plataforma, seus recursos e as soluções disponíveis.',
    href: 'https://agno.app.br',
    faviconDomain: 'agno.app.br',
    image: '/agno.png',
    badge: 'SITE OFICIAL',
    accent: 'from-slate-950 via-blue-900 to-cyan-600',
  },
];

const PODCASTS = [
  {
    label: 'Podcast Federação',
    desc: 'YouTube Live',
    href: 'https://www.youtube.com/live/vTC2jRpH1cQ?si=X5FAq9KBaRH_J7mA',
    icon: <Youtube className="w-5 h-5" />,
    color: 'bg-red-600',
  },
  {
    label: 'Podcast Barber Room Educacional',
    desc: 'YouTube Live',
    href: 'https://www.youtube.com/live/7Zth90b6RZI?si=9QsTkTrVqBF8Df7q',
    icon: <Youtube className="w-5 h-5" />,
    color: 'bg-red-600',
  },
  {
    label: 'Podcast Educador Cleitin Du Corte',
    desc: 'YouTube',
    href: 'https://youtu.be/14-1M5pJKdo?si=EbJq0TYVD6a5xL8A',
    icon: <Youtube className="w-5 h-5" />,
    color: 'bg-red-600',
  },
  {
    label: 'Hairstyle The Talent Show',
    desc: 'Espanha — competição internacional',
    href: 'https://www.instagram.com/fepcssp',
    icon: <Mic className="w-5 h-5" />,
    color: 'bg-amber-700',
  },
];

const ANVISA = [
  {
    label: 'Passo a passo para abrir uma empresa',
    desc: 'Guia Sebrae-SC',
    href: 'https://www.sebrae-sc.com.br/blog/passo-passo-para-abrir-uma-empresa',
  },
  {
    label: 'ANVISA proíbe ácido glioxílico como alisante',
    desc: 'Nota oficial — julho/2025',
    href: 'https://www.gov.br/anvisa/pt-br/assuntos/noticias-anvisa/2025/anvisa-alerta-para-riscos-a-saude-associados-ao-uso-de-alisantes-capilares-irregulares',
  },
  {
    label: 'Consulte alisantes liberados pela ANVISA',
    desc: 'Base de dados Power BI',
    href: 'https://app.powerbi.com/view?r=eyJrIjoiZGYyZDMwMDQtNGIwMy00MzdmLWI4ZmEtOTgzYTFmMDRmMDEwIiwidCI6ImI2N2FmMjNmLWMzZjMtNGQzNS04MGM3LWI3MDg1ZjVlZGQ4MSJ9',
  },
  {
    label: 'ANVISA — lista de pomadas autorizadas',
    desc: 'Portal gov.br',
    href: 'https://www.gov.br/anvisa/pt-br/assuntos/cosmeticos/pomadas/pomadas-autorizadas',
  },
  {
    label: 'ANVISA aprova Ozonioterapia estética',
    desc: 'Limpeza de pele — indicações aprovadas',
    href: 'https://www.gov.br/anvisa/pt-br/assuntos/noticias-anvisa/2022/ozonioterapia-anvisa-esclarece-as-indicacoes-aprovadas-ate-o-momento',
  },
];

const PIX_KEYS = [
  { label: 'Chave Pix (E-mail)', value: 'pix@federacaodoscabeleireiros.com.br' },

];

// ── Sub-componentes ─────────────────────────────────────────────────────────

function SectionTitle({ icon, children }: { icon: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-2 mb-4 mt-8">
      <span className="text-amber-600">{icon}</span>
      <h2 className="text-sm font-bold uppercase tracking-widest text-gray-500">{children}</h2>
      <div className="flex-1 h-px bg-gray-200" />
    </div>
  );
}

function LinkCard({
  label, desc, href, icon, color, badge, badgeColor,
}: {
  label: string; desc?: string; href: string;
  icon?: React.ReactNode; color?: string;
  badge?: string; badgeColor?: string;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-4 p-4 min-h-[60px] rounded-xl border border-gray-100 bg-white hover:bg-amber-50 hover:border-amber-200 active:scale-95 transition-all duration-200 group shadow-sm hover:shadow-md"
    >
      {icon && color && (
        <span className={`${color} text-white p-2 rounded-lg flex-shrink-0`}>
          {icon}
        </span>
      )}
      {icon && !color && (
        <span className="text-2xl flex-shrink-0 leading-none">{icon}</span>
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-semibold text-gray-900 text-sm group-hover:text-amber-700 transition-colors">
            {label}
          </span>
          {badge && (
            <span className={`${badgeColor} text-white text-xs font-bold px-2 py-0.5 rounded-full`}>
              {badge}
            </span>
          )}
        </div>
        {desc && <p className="text-xs text-gray-500 truncate mt-0.5">{desc}</p>}
      </div>
      <ExternalLink className="w-4 h-4 text-gray-300 group-hover:text-amber-500 flex-shrink-0 transition-colors" />
    </a>
  );
}

function FeaturedLinkCard({
  label, desc, details, href, faviconDomain, image, badge, accent,
}: {
  label: string; desc: string; details: string; href: string;
  faviconDomain: string; image?: string; badge: string; accent: string;
}) {
  const [expanded, setExpanded] = useState(false);
  const [faviconFailed, setFaviconFailed] = useState(false);
  const panelId = `link-details-${faviconDomain.replace(/[^a-z0-9]/gi, '-')}`;
  const faviconUrl = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(faviconDomain)}&sz=128`;

  return (
    <article className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg">
      <button
        type="button"
        onClick={() => setExpanded((current) => !current)}
        aria-expanded={expanded}
        aria-controls={panelId}
        className="block w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-inset"
      >
        <div className={`relative flex min-h-[150px] items-center justify-center overflow-hidden bg-gradient-to-br ${accent} p-6`}>
          {image ? (
            <img
              src={image}
              alt={`Identidade visual ${label}`}
              className="absolute inset-0 h-full w-full bg-black object-contain"
            />
          ) : (
            <>
              <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-white/10" />
              <div className="absolute -bottom-10 -left-8 h-32 w-32 rounded-full bg-white/10" />
            </>
          )}
          <span className="absolute left-4 top-4 rounded-full border border-white/25 bg-black/25 px-2.5 py-1 text-[10px] font-black tracking-wider text-white backdrop-blur-sm">
            {badge}
          </span>
          {!image && (
            <span className="relative flex h-20 w-20 items-center justify-center rounded-2xl border border-white/30 bg-white p-3 shadow-2xl">
              {!faviconFailed ? (
                <img
                  src={faviconUrl}
                  alt=""
                  className="h-full w-full object-contain"
                  onError={() => setFaviconFailed(true)}
                />
              ) : (
                <Globe className="h-10 w-10 text-gray-700" aria-hidden="true" />
              )}
            </span>
          )}
        </div>

        <div className="flex items-start gap-3 p-4">
          <div className="min-w-0 flex-1">
            <h3 className="text-sm font-black leading-snug text-gray-900">{label}</h3>
            <p className="mt-1 text-xs leading-relaxed text-gray-500">{desc}</p>
          </div>
          <ChevronDown
            className={`mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600 transition-transform duration-300 ${expanded ? 'rotate-180' : ''}`}
            aria-hidden="true"
          />
        </div>
      </button>

      <div
        id={panelId}
        className={`grid transition-all duration-300 ease-out ${expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
      >
        <div className="overflow-hidden">
          <div className="border-t border-gray-100 px-4 pb-4 pt-3">
            <p className="text-xs leading-relaxed text-gray-600">{details}</p>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gray-900 px-4 py-3 text-xs font-bold text-white transition-colors hover:bg-amber-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2"
            >
              Acessar agora <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </article>
  );
}

function AnvisaCard({ label, desc, href }: { label: string; desc: string; href: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="block px-4 py-3 rounded-lg border border-gray-100 bg-white hover:bg-amber-50 hover:border-amber-200 transition-all duration-200 group shadow-sm"
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="font-medium text-sm text-gray-900 group-hover:text-amber-700 transition-colors">{label}</p>
          <p className="text-xs text-gray-400 mt-0.5">{desc}</p>
        </div>
        <ExternalLink className="w-4 h-4 text-gray-300 group-hover:text-amber-500 flex-shrink-0 mt-0.5 transition-colors" />
      </div>
    </a>
  );
}

function PixCard({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
      <p className="text-xs font-bold uppercase tracking-widest text-amber-700 mb-1">{label}</p>
      <div className="flex items-center gap-2">
        <code className="text-xs font-mono text-gray-700 flex-1 break-all">{value}</code>
        <button
          onClick={copy}
          className="flex-shrink-0 bg-amber-600 hover:bg-amber-700 text-white rounded-lg p-2 transition-colors"
          aria-label={`Copiar ${label}`}
        >
          {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
        </button>
      </div>
      {copied && <p className="text-xs text-green-600 font-medium mt-1">Chave copiada!</p>}
    </div>
  );
}

// ── Página principal ────────────────────────────────────────────────────────

const Links: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-neutral-900 via-neutral-800 to-amber-900 text-white py-14 px-4">
        <div className="max-w-lg mx-auto text-center">
          <img
            src="/imagem/Bras.png"
            alt="Brasão FEPCSSP"
            className="w-24 h-24 mx-auto mb-4 object-contain drop-shadow-lg"
          />
          <h1 className="text-2xl font-bold leading-tight">
            Federação das Escolas Profissionais de Cabeleireiros e Similares do Brasil
          </h1>
          <p className="text-amber-400 font-semibold mt-1 text-sm tracking-wide">
            Entidade Regulamentadora do Setor · Internacional
          </p>
          <p className="text-gray-300 text-sm mt-3 leading-relaxed max-w-sm mx-auto">
            Credenciamento de escolas, emissão de registros federativos e suporte institucional
            em mais de 130 países — sem taxas mensais.
          </p>
        </div>
      </div>

      {/* Conteúdo */}
      <div className="max-w-lg mx-auto px-4 pb-16">

        {/* Redes Sociais */}
        <SectionTitle icon={<Globe className="w-4 h-4" />}>Redes Sociais</SectionTitle>
        <div className="space-y-3">
          {REDES.map((item) => (
            <LinkCard key={item.href} {...item} />
          ))}
        </div>

        {/* Contato */}
        <SectionTitle icon={<Phone className="w-4 h-4" />}>Contato</SectionTitle>
        <div className="space-y-3">
          {CONTATO.map((item) => (
            <LinkCard key={item.href} {...item} />
          ))}
        </div>

        {/* Eventos */}
        <SectionTitle icon={<Calendar className="w-4 h-4" />}>Eventos &amp; Oportunidades</SectionTitle>
        <p className="-mt-2 mb-4 text-xs leading-relaxed text-gray-500">
          Toque em um destaque para saber mais antes de acessar.
        </p>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {EVENTOS.map((item) => (
            <FeaturedLinkCard key={item.href} {...item} />
          ))}
        </div>

        {/* Filiação e Doação */}
        <SectionTitle icon={<HeartHandshake className="w-4 h-4" />}>Filiação &amp; Doação</SectionTitle>
        <div className="space-y-3">
          {FILIACAO_DOACAO.map((item) => (
            <LinkCard key={item.href} {...item} />
          ))}
        </div>

        {/* Sites em destaque */}
        <SectionTitle icon={<Globe className="w-4 h-4" />}>Sites em destaque</SectionTitle>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {DESTAQUES.map((item) => (
            <FeaturedLinkCard key={item.href} {...item} />
          ))}
        </div>

        {/* Podcasts */}
        <SectionTitle icon={<Mic className="w-4 h-4" />}>Conteúdo &amp; Podcasts</SectionTitle>
        <div className="space-y-3">
          {PODCASTS.map((item) => (
            <LinkCard key={item.href} {...item} />
          ))}
        </div>

        {/* ANVISA / Informações */}
        <SectionTitle icon={<FlaskConical className="w-4 h-4" />}>
          Informações do Setor
        </SectionTitle>
        <div className="space-y-2">
          {ANVISA.map((item) => (
            <AnvisaCard key={item.href} {...item} />
          ))}
        </div>

        {/* Pix */}
        <SectionTitle icon={<Building2 className="w-4 h-4" />}>Pagamento</SectionTitle>
        <div className="space-y-3">
          {PIX_KEYS.map((pix) => (
            <PixCard key={pix.label} {...pix} />
          ))}
        </div>

        {/* Rodapé */}
        <p className="text-center text-xs text-gray-400 mt-10">
          © {new Date().getFullYear()} FEPCSSP — Federação das Escolas Profissionais de Cabeleireiros e Similares do Brasil Internacional
        </p>
      </div>
    </div>
  );
};

export default Links;
